import { useAuth } from 'react-oidc-context'

const rolesClaimName = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';
const groupsClaimName = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/groups';

function getRolesFromProfile(profile: Record<string, unknown> | undefined): string[] {
    const claimRoles = profile?.[rolesClaimName] ?? []; // Access the roles from the JWT claim
    return claimRoles instanceof Array ? claimRoles : [claimRoles];
}

function useIsInRoles(roles: string[] | string | undefined): boolean {
    const auth = useAuth()

    const arrayOfRoles = getRolesFromProfile(auth.user?.profile);
    const checksRoles = roles instanceof Array ? roles : [roles];
    const isContains =
        roles == undefined || roles.length === 0 || arrayOfRoles.some((x) => checksRoles.some((role) => role === x));

    return auth.isAuthenticated && isContains; // Ensure the user is authenticated and in the role
}
function useIsInGroups(groups: string[] | string | undefined | null): boolean {
    const auth = useAuth();

    // Use the correct claim name for groups as seen in the screenshot
    const claimGroups = auth.user?.profile[groupsClaimName] ?? []; // Access the groups from the JWT claim

    const arrayOfGroups = claimGroups instanceof Array ? claimGroups : [claimGroups];
    const checksGroups = groups instanceof Array ? groups : [groups];
    const isContains =
        groups == null ||
        groups == undefined ||
        groups.length === 0 ||
        arrayOfGroups.some((x) => checksGroups.some((group) => group === x));

    return isContains; // Ensure the user is authenticated and in the group
}

export type AccessTokenValidationParameters = {
    isLoggedIn: boolean;
    isInRoles: boolean;
};

function useAccessTokenValidation(roles: string[] | string | undefined): AccessTokenValidationParameters {
    const auth = useAuth();

    const arrayOfRoles = getRolesFromProfile(auth.user?.profile);
    const checksRoles = roles instanceof Array ? roles : [roles];
    const isContains =
        roles == undefined || roles.length === 0 || arrayOfRoles.some((x) => checksRoles.some((role) => role === x));
    const isLoggedIn = auth.isAuthenticated;

    return {
        isLoggedIn: isLoggedIn,
        isInRoles: isContains,
    };
}

export default { useIsInRoles, useIsInGroups, useAccessTokenValidation, getRolesFromProfile };
